<!-- eslint-disable vue/require-explicit-emits -->
<template>
  <iColumn
    class="invalid-element"
    width="hug"
    height="hug"
    align="center"
    vertical-align="middle"
    gap="extraSmall"
    :style-overrides="{
      paddingTop: 'standard',
      paddingRight: 'standard',
      paddingBottom: 'standard',
      paddingLeft: 'standard',
      borderRadius: 'large',
    }"
  >
    <iIcon size="large" name="teenyicons:mood-sad-outline" />
    <iText font-size="standard" font-weight="semibold">
      Invalid Element
    </iText>
    <iText variant="subtle" font-size="small">
      {{ name }}
    </iText>
  </iColumn>
</template>

<script>
// Visible fallback rendered by `DynamicComponentBuilderElement` when an
// element entity references a `type` that has no registered Vue
// component — typically a legacy / removed element type that survived
// in persisted data (e.g. a paste from old dynamic-component JSON).
//
// The fallback prints the original type name so users can identify the
// orphan in the canvas and delete it without crashing the render. The
// surrounding builder element wrapper handles selection / drag / delete
// affordances; this component only owns the visible body.

export default {
  name: "InvalidElement",
  props: {
    name: {
      type: String,
      default: "Unknown",
    },
  },
  elementPanelSettings: {
    displayName: "Invalid Element",
    displayIcon: "teenyicons:mood-sad-outline",
    elementGroup: "general",
    elementType: "element",
  },
  deprecated: true,
};
</script>

<style scoped lang="scss">
.invalid-element {
  border: 1px dashed currentColor;
  opacity: 0.7;
}
</style>
